import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as homeActions from '../actions';
import { produceOn } from '../../../../reducers/immer.helper';
import { error } from 'console';

export interface HomeState {
  heroBanners?: any[];
  megaMenu?: any[];
  press?: any[];
  packageThemes?: any[];
  packageCategory?: any[];
  footerLinks?: any[];
  quickLinks?: any[];
  siteSettings?: any;
  exclusiveDeals?: any[];
  travellerStories?: any[];
  isLoading?: boolean;
  error?: any;
  explorePackages?: any[];
  blogPost?: any[];
  blogCategories?: any[];
}

export const initialState: HomeState = {
  heroBanners: [],
  press: [],
  packageThemes: [],
  footerLinks: [],
  quickLinks: [],
  megaMenu: [],
  packageCategory: [],
  siteSettings: {},
  exclusiveDeals: [],
  travellerStories: [],
  isLoading: false,
  error: null,
  explorePackages: [],
  blogPost: [],
};

const HomeReducer = createReducer(
  initialState,
  produceOn(homeActions.getAllPress, (draft, result) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllPressSuccess, (draft, result) => {
    draft.press = result.data;
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllPressFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),

  produceOn(homeActions.getAllFooterLinks, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllFooterLinksSuccess, (draft, result) => {
    draft.footerLinks = result.data;
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllFooterLinksFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),
  produceOn(homeActions.getAllQuickLinks, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllQuickLinksSuccess, (draft, result) => {
    draft.quickLinks = result.data.data;
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllQuickLinksFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),
  produceOn(homeActions.getAllSiteSettings, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllSiteSettingsSuccess, (draft, result) => {
    draft.siteSettings = result.data; // Set siteSettings array from the result
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllSiteSettingsFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),
  produceOn(homeActions.getAllHeroBanners, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllHeroBannersSuccess, (draft, result) => {
    draft.heroBanners = result.data; // Set heroBanners array from the result
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllHeroBannersFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),

  produceOn(homeActions.getAllMegaMenu, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllMegaMenuSuccess, (draft, result) => {
    draft.megaMenu = result.data;
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllMegaMenuFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),

  produceOn(homeActions.getAllPackageThemes, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllPackageThemesSuccess, (draft, result) => {
    draft.packageThemes = result.data; // Set heroBanners array from the result
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllPackageThemesFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),

  produceOn(homeActions.getAllBlogCategories, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllBlogCategoriesSuccess, (draft, result) => {
    draft.blogCategories = result.data; // Set blogCategories array from the result
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllBlogCategoriesFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),

  produceOn(homeActions.getPackageCategory, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getPackageCategorySuccess, (draft, result) => {
    draft.packageCategory = result.data.data;
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getPackageCategoryFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),

  produceOn(homeActions.getExclusiveDeals, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getExclusiveDealsSuccess, (draft, result) => {
    draft.exclusiveDeals = result.data;
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getExclusiveDealsFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),
  produceOn(homeActions.getTravellerStories, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getTravellerStoriesSuccess, (draft, result) => {
    draft.travellerStories = result.data; // Set siteSettings array from the result
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getTravellerStoriesFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  }),
  produceOn(homeActions.getAllBlogPost, (draft) => {
    draft.isLoading = true;
  }),
  produceOn(homeActions.getAllBlogPostSuccess, (draft, result) => {
    draft.blogPost = result.data;
    draft.isLoading = false;
    draft.error = null;
  }),
  produceOn(homeActions.getAllBlogPostFailure, (draft, error) => {
    draft.isLoading = false;
    draft.error = error;
  })
);

export function reducer(state: HomeState | undefined, action: Action): any {
  return HomeReducer(state, action);
}
